import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EmpresaService } from '../../../services/empresa.service';
import {proyecto} from '../../../models/proyecto';
import {empresa} from '../../../models/empresa';
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-new-empresa',
  templateUrl: './new-empresa.component.html',
  styleUrls: ['./new-empresa.component.css']
})
export class NewEmpresaComponent implements OnInit {

  nombre: string;
  CIF: string;
  direccion: string;
  telefono: string;
  email: string;
  logo: string;

  constructor(public dialogRef: MatDialogRef<NewEmpresaComponent>, private empresaService: EmpresaService,
              public localiser: Localiser) { }

  ngOnInit(): void {
  }

  newEmpresa() {
    let empresa: empresa = {
      idEmpresa: "ID",
      nombre: this.nombre,
      cif: this.CIF,
      direccion: this.direccion,
      telefono: this.telefono,
      email: this.email,
      logo: '',
      proyectos: []
    }
    this.empresaService.new(empresa).subscribe(result => {
      this.dialogRef.close();
    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
